import { css } from 'lit';

export const SHARED_ELEMENTS = css`
  h1 {
    font-size: calc(20rem / var(--default-rem-px-count));
    line-height: calc(26rem / var(--default-rem-px-count));
    letter-spacing: -0.6px;
    font-weight: 400;
    margin: 0;
  }

  h2 {
    font-size: calc(18rem / var(--default-rem-px-count));
    letter-spacing: -0.24px;
    line-height: calc(22rem / var(--default-rem-px-count));
    font-weight: 400;
    margin: 0;
  }

  h3 {
    font-size: calc(10rem / var(--default-rem-px-count));
    letter-spacing: -0.15px;
    line-height: calc(16rem / var(--default-rem-px-count));
    font-weight: 400;
    margin: 0;
  }

  p {
    font-size: calc(14rem / var(--default-rem-px-count));
    letter-spacing: -0.18px;
    line-height: calc(21rem / var(--default-rem-px-count));
    font-weight: 400;
    margin: 0;
  }

  a,
  a:visited,
  a:hover,
  a:active {
    color: inherit;
    text-decoration: none;
  }

  * {
    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgb(34, 34, 34) white;
  }

  *::-webkit-scrollbar-track {
    background-color: #ffffff;
  }

  *::-webkit-scrollbar {
    height: 2px;
    width: 2px;
    background-color: #ffffff;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #222222;
    border: none;
  }

  *::-webkit-scrollbar-button {
    display: none;
  }

  @media (min-width: 600px) {
    h1 {
      font-size: calc(40rem / var(--default-rem-px-count));
      line-height: calc(48rem / var(--default-rem-px-count));
      letter-spacing: -1.28px;
      font-weight: 400;
      margin: 0;
    }

    h2 {
      font-weight: 400;
      font-size: 2em;
      letter-spacing: -1.12px;
      line-height: 1.25em;
      margin: 0;
    }

    h3 {
      font-weight: 400;
      font-size: calc(14rem / var(--default-rem-px-count));
      letter-spacing: unset;
      margin: 0;
      line-height: calc(20rem / var(--default-rem-px-count));
    }

    p {
      font-weight: 400;
      font-size: 1em;
      letter-spacing: -0.24px;
      line-height: 1.5em;
      margin: 0;
    }
  }
`;

export const SHARED_CLASSES = css`
  .description-text {
    margin-top: 3.75rem;
    margin-bottom: 2.25rem;
  }

  .cta-plain-text {
    font-weight: 500;
    font-size: 0.875rem;
    letter-spacing: -0.21px;
    line-height: 1.25em;
    white-space: nowrap;
  }

  .font-size-small {
    font-size: calc(10rem / var(--default-rem-px-count));
  }

  .cta-plain-text > span {
    padding-right: 15px;
  }

  .block-wrapper {
    max-width: 1440px;
    margin: 0 auto;
  }

  horizontal-rule {
    grid-column: 2 / 8;
    grid-row: last-line;
    border-bottom-style: solid;
    border-bottom-color: #c0c0c0;
    z-index: -1;
  }

  .cta-btn {
    width: fit-content;
    white-space: nowrap;
  }

  .bold {
    font-weight: 500;
  }

  .font-16 {
    font-size: calc(16rem / var(--default-rem-px-count));
  }

  .download-cursor {
    cursor: url('/static/icons/SVG/download-12x16.svg')
        var(--default-rem-px-count) var(--default-rem-px-count),
      pointer;
  }

  .not-mobile {
    display: none;
  }

  .mobile-only {
    display: initial;
  }

  vimeo-video {
    display: contents;
    position: absolute;
    width: 100%;
  }

  @media (min-width: 600px) {
    horizontal-rule {
      grid-column: 2 / 14;
      grid-row: 1 / last-line;
    }

    .font-size-small {
      font-size: calc(14rem / var(--default-rem-px-count));
    }

    .not-mobile {
      display: initial;
    }

    .mobile-only {
      display: none;
    }

    vimeo-video {
      height: 100%;
    }
  }

  /*
    !important because if it isn't supposed to be hidden it shouldn't have this
    class
  */
  .hidden {
    display: none !important;
  }

  .print-only {
    display: none;
  }

  @media print {
    /*
      !important seems to be necessary as specificity cannot be changed and it
      is otherwise needed for expected results
      This also seems to be an acceptable case for !important
    */
    .print-none {
      display: none !important;
    }

    .print-hidden {
      visibility: hidden !important;
    }

    .print-only {
      display: initial;
    }
  }
`;
